/* eslint-disable camelcase */
import * as React from 'react';
import { ISelectInputOption } from '@rocketmakers/armstrong';

import { DeviceType } from '../../../shared/api-clients/_api';
import { useBeeConfig } from '../hooks/beeConfig';
import { relays } from '../../../shared/helpers/configurationOptionGenerator';
import { FilterSelect, IFilterSelectProps } from '../../../shared/components/filter-select';

const controlTypeOptions = relays.map<ISelectInputOption>(value => ({
  id: value,
  name: `Relay ${value}`,
}));

export type ISelectAvailableRelayProps = Omit<IFilterSelectProps, 'options'> & {
  initialValue?: number | string;
  groupInitialValues?: number[] | string[];
};

export const SelectAvailableRelay: React.FunctionComponent<ISelectAvailableRelayProps> = ({
  initialValue,
  groupInitialValues = [],
  ...props
}) => {
  const { getAssignedResourcesFor } = useBeeConfig();
  const assigned = getAssignedResourcesFor([DeviceType.RELAY], 'address', initialValue, ...groupInitialValues).map(
    Number
  );

  return (
    <FilterSelect
      data-qa="select-relay"
      {...props}
      options={controlTypeOptions}
      filterOptions={[...assigned, ...(props.filterOptions ?? [])]}
    />
  );
};
